import React, { useCallback } from 'react';
import { ScreenWrapper } from '../../components/Wrappers/ScreenWrapper';
import { Grid2 } from '@mui/material';
import { TMaterialStyles } from '../../theme';
import { LoginButton, TelegramAuthData } from '@telegram-auth/react';
import { getUserProfileInitialFlowData, signUp } from '../../queries';
import { LOCAL_STORAGE_TELEGRAM_INIT_DATA_KEY, request } from '../../api';
import { encodeQueryParams } from '../../helpers';

const BOT_USERNAME = import.meta.env.VITE_BOT_USERNAME;

const ConnectAccountByOAuthWidgetScreen: React.FC = () => {
  const onAuthCallback = useCallback(async (data: TelegramAuthData) => {
    try {
      const initData = encodeQueryParams(data);

      request.interceptors.request.use((config) => {
        config.headers['Authorization'] = `Bearer ${initData}`;
        return config;
      });

      localStorage.setItem(LOCAL_STORAGE_TELEGRAM_INIT_DATA_KEY, initData);

      await signUp();
      await getUserProfileInitialFlowData();
    } catch (error) {
      console.error('Error while [onAuthCallback]', error);
    }
  }, []);

  return (
    <ScreenWrapper>
      <Grid2 sx={materialStyles.container}>
        <LoginButton
          botUsername={BOT_USERNAME}
          onAuthCallback={onAuthCallback}
        />
      </Grid2>
    </ScreenWrapper>
  );
};

const materialStyles: TMaterialStyles = {
  container: {
    display: 'flex',
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
  },
};

export default ConnectAccountByOAuthWidgetScreen;
